module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.DBSLogoResized-f349cbf37ab1e130ebf6870496f549c5.png";